document.addEventListener("DOMContentLoaded", function () {
    let currentPage = 1;
    const collectionHandle = window.location.pathname.split('/').pop();
    const productGrid = document.getElementById("product-grid");
    let loadMoreButton = null;
    let isLoading = false;

    // Crear y agregar el botón "Ver más"
    function createLoadMoreButton() {
        if (loadMoreButton) return;

        loadMoreButton = document.createElement('button');
        loadMoreButton.innerText = "Ver más";
        loadMoreButton.className = "load-more-button";
        loadMoreButton.addEventListener('click', loadMoreProducts);

        productGrid.insertAdjacentElement('afterend', loadMoreButton);
    }

    // Función para cargar más productos
    async function loadMoreProducts() {
        if (isLoading) return;

        isLoading = true;
        currentPage += 1;
        const nextPageUrl = `/collections/${collectionHandle}?page=${currentPage}`;

        try {
            const response = await fetch(nextPageUrl);
            if (!response.ok) throw new Error('Failed to fetch more products');

            const html = await response.text();
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            const newProducts = tempDiv.querySelectorAll("#product-grid .grid__item");
            newProducts.forEach(product => productGrid.appendChild(product));

            const hasMoreProducts = !!tempDiv.querySelector(".pagination__item--next");
            if (!hasMoreProducts) loadMoreButton.style.display = 'none';
        } catch (error) {
            console.error("Error al cargar más productos:", error);
        } finally {
            isLoading = false;
        }
    }

    // Inicializar el botón "Ver más" al cargar la página
    createLoadMoreButton();
});
